import { ReactNode } from 'react';
import Link from 'next/link';
import { LINKS } from '@/app/_contants/index';

export const DROPDOWN_ITEMS: ReactNode[] = [
  <Link href={'/account'}>会員情報</Link>,
  <Link href={LINKS.POLICY} target="_blank">
    利用規約
  </Link>,
  <Link href={LINKS.PRIVACY} target="_blank">
    プライバシーポリシー
  </Link>,
];
